import type { LucideIcon } from "lucide-react";

interface DownloadProps {
	image?: string;
	icon?: LucideIcon;
	href: string;
	filename?: string;
};

export default function Download({ image, icon: Icon, href, filename }: DownloadProps) {
	return (
		<a
			href={href}
			download={filename}
			className="block w-[20px] h-[20px] will-change-transform transition-transform duration-700 ease-out hover:scale-110 hover:brightness-110 hover:cursor-pointer"
		>
			{image ? (
				<img src={image} alt="" className="w-full h-full object-contain" />
			) : Icon ? (
				<Icon className="w-full h-full text-primary" />
			) : null}
		</a>
	);
}
